import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-ai-center p-jc-end"
}
const _hoisted_2 = {
  key: 1,
  class: "p-ml-2 p-field"
}
const _hoisted_3 = { class: "p-d-flex p-ai-center p-jc-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-briefcase" }, null, -1)
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", { class: "p-ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createTextVNode(" Il risultato della ricerca verrà applicato ai campi sottostanti. ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-wallet" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-h" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-credit-card" }, null, -1)
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = { class: "p-inputtext p-component p-disabled" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", {
  hidden: "",
  type: "submit"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_VInputSwitch = _resolveComponent("VInputSwitch")!
  const _component_VInputText = _resolveComponent("VInputText")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_CityAutocomplete = _resolveComponent("CityAutocomplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_VTextArea = _resolveComponent("VTextArea")!

  return (_openBlock(), _createElementBlock("form", {
    id: "customer-form",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Skeleton, {
            class: "p-mr-3",
            height: "1rem",
            width: "6rem"
          }),
          _createVNode(_component_Skeleton, {
            height: "2rem",
            width: "3rem"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VInputSwitch, {
              labelOff: _ctx.$t('inactive'),
              labelOn: _ctx.$t('active') ,
              name: "is_active"
            }, null, 8, ["labelOff", "labelOn"])
          ])
        ])),
    _createVNode(_component_Fieldset, { class: "p-fluid" }, {
      legend: _withCtx(() => [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.user_data')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              }),
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "2rem"
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.name') + ' *',
                autofocus: "",
                field: "name"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.surname') + ' *',
                field: "surname"
              }, null, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.business_data')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (a) => {
              return _createVNode(_component_Skeleton, {
                key: `company_${a}`,
                class: "p-mb-2",
                height: "2rem"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_name') + ' *',
                field: "business_name"
              }, null, 8, ["label"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('entity.business_city') + ' *'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CityAutocomplete, {
                      modelValue: _ctx.businessCity,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.businessCity = $event)),
                      class: _normalizeClass({
              'p-invalid': (_ctx.business_city_meta.touched) && _ctx.business_city_errors?.length
            })
                    }, null, 8, ["modelValue", "class"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                ((_ctx.business_city_meta.touched) && _ctx.business_city_errors?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.business_city_errors, (e) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: e,
                        class: "p-error"
                      }, _toDisplayString(_ctx.$t(e)), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AddressAutocomplete, {
                  modelValue: _ctx.business_address,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.business_address = $event)),
                  label: "Cerca indirizzo",
                  onSelectedAddress: _ctx.onSelectAddress
                }, null, 8, ["modelValue", "onSelectedAddress"]),
                _hoisted_8
              ]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_address') + ' *',
                field: "business_address"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_state'),
                field: "business_state"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_province'),
                field: "business_province"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_postal_code') + ' *',
                field: "business_postal_code"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.sdi'),
                field: "sdi"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.vat') + ' *',
                field: "vat"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.fiscal_code') + ' *',
                field: "fiscal_code"
              }, null, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_9,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.contact_details')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (a) => {
              return _createVNode(_component_Skeleton, {
                key: `contacts_${a}`,
                class: "p-mb-2",
                height: "2rem"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.business_tel') + ' *',
                field: "business_tel",
                maxlength: "15"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.pec') + ' *',
                field: "pec",
                type: "email"
              }, null, 8, ["label"]),
              _createVNode(_component_VInputText, {
                label: _ctx.$t('entity.email') + ' *',
                field: "email",
                type: "email"
              }, null, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_10,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.payment_section')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (a) => {
                return _createVNode(_component_Skeleton, {
                  key: `payments_${a}`,
                  class: "p-mb-2",
                  height: "2rem"
                })
              }), 64)),
              _createVNode(_component_Skeleton, {
                class: "p-mb-2",
                height: "5rem"
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_VDropdown, {
                id: "payment_type-dropdown",
                label: _ctx.$t('entity.payment_type') + ' *',
                options: _ctx.paymentOptions,
                name: "payment_type",
                optionLabel: "label",
                optionValue: "value"
              }, null, 8, ["label", "options"]),
              _createVNode(_component_VTextArea, {
                id: "business_note",
                autoResize: true,
                label: _ctx.$t('entity.business_note'),
                cols: "30",
                field: "business_note",
                rows: "5"
              }, null, 8, ["label"])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_11,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.other')), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "p-mb-2",
              height: "5rem"
            }))
          : (_openBlock(), _createBlock(_component_VTextArea, {
              key: 1,
              id: "note",
              autoResize: true,
              label: _ctx.$t('entity.note'),
              cols: "30",
              field: "note",
              rows: "5"
            }, null, 8, ["label"]))
      ]),
      _: 1
    }),
    (_ctx.customer?.type === _ctx.UserType.APP_CUSTOMER)
      ? (_openBlock(), _createBlock(_component_Fieldset, {
          key: 2,
          class: "p-fluid p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('entity.banking_info')), 1)
          ]),
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (a) => {
                  return _createVNode(_component_Skeleton, {
                    key: `banking_${a}`,
                    class: "p-mb-2",
                    height: "2rem"
                  })
                }), 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_VInputText, {
                    label: _ctx.$t('entity.iban_intestatario'),
                    field: "iban_intestatario"
                  }, null, 8, ["label"]),
                  _createVNode(_component_VInputText, {
                    label: _ctx.$t('entity.iban'),
                    field: "iban"
                  }, null, 8, ["label"]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('entity.rating_avg')), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.customer?.rating_avg || 'N/A'), 1)
                  ])
                ], 64))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_15
  ], 32))
}